import { Component, Output, Input, HostListener, ViewChild, EventEmitter, Inject, Pipe, PipeTransform, OnDestroy, ElementRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {MatDatepicker} from '@angular/material/datepicker';

import { Utils } from '../utils';
import { GettyService } from './getty.service';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';


@Pipe({name: 'activeSearch', pure: false})
export class ActiveSearchPipe implements PipeTransform {
    transform(object) {
        if( !object ) {
            return object;
        }
        const keys = Object.keys(object);
        let options = [];
        for(var i = 0; i < keys.length; i++) {
            const key = keys[i];
            if( key != 'sort_order' ) {
                options.push(...object[key].options);
            }
            if( object[key].search && key != 'date_to' && key != 'date_from' ) {
                options.push({
                    label: object[key].search,
                    checked: true,
                    search: key
                });        
            }
        }
        if( object.date_from.search && object.date_to.search ) {
            const dateFrom = new Date(object.date_from.search);
            const displayDateFrom = (dateFrom.getMonth() + 1) + '/' + (dateFrom.getDate() + 1) + '/' + dateFrom.getFullYear();
            const dateTo = new Date(object.date_to.search);
            const displayDateTo = (dateTo.getMonth() + 1) + '/' + (dateTo.getDate() + 1) + '/' + dateTo.getFullYear();
            options.push({
                label: displayDateFrom + '&mdash;' + displayDateTo,
                checked: true,
                search: 'date_from,date_to'
            });
        }
        return options.filter(item => item.checked);
    }
}
@Component({
    selector: 'getty-images',
    templateUrl: 'getty.component.html'
})
export class GettyComponent implements OnDestroy {
    captionCharacterCount = 45;
    selected = null;
    filterGroups = [
        {
            label: 'Sort',
            filters: ['sort_order'],
            open: false
        },
        {
            label: 'People',
            filters: ['age_of_people', 'compositions', 'ethnicity', 'number_of_people', 'specific_people'],
            open: false
        },
        {
            label: 'Date',
            filters: ['date_from'],
            open: false
        },
        {
            label: 'Category',
            filters: ['editorial_segments'],
            open: false
        },
        {
            label: 'Framing',
            filters: ['orientations'],
            open: false
        },
        {
            label: 'Event',
            filters: ['event_ids'],
            open: false
        },
        {
            label: 'Location',
            filters: ['keyword_ids'],
            open: false
        },
        {
            label: 'Photographer',
            filters: ['artists'],
            open: false
        }
    ];
    fromMaxDate = new Date();
    toMaxDate = new Date();
    minDate;
    searchField = new FormControl();
    searchFieldSubscription;
    gettySearchInput = this.utils.rand();
    resizeEvent = new Subject();
    resizeEventSubscription;
    imagesUpdatedSubscription;
    downloadSubscription;
    lists = [[], [], []];

    private _addToSlide = false;
    private _canEdit = false;
    private _id = 0;
    private _quiz = false;
    private _removeEditButton = false;
    private _slide = false;
    private _window = false;
    @Input('addToSlide')
    set addToSlide(addToSlide) {
        this._addToSlide = addToSlide;
    }
    get addToSlide() {
        return this._addToSlide;
    }
    @Input('canEdit')
    set canEdit(canEdit) {
        this._canEdit = canEdit;
    }
    get canEdit() {
        return this._canEdit;
    }
    @Input('id')
    set id(id) {
        this._id = id;
    }
    get id() {
        return this._id;
    }
    @Input('quiz')
    set quiz(quiz) {
        this._quiz = quiz;
    }
    get quiz() {
        return this._quiz;
    }
    @Input('removeEditButton')
    set removeEditButton(removeEditButton) {
        this._removeEditButton = removeEditButton;
    }
    get removeEditButton() {
        return this._removeEditButton;
    }
    @Input('slide')
    set slide(slide) {
        this._slide = slide;
    }
    get slide() {
        return this._slide;
    }
    @Input('window')
    set window(window) {
        this._window = window;
    }
    get window() {
        return this._window;
    }

    @Output() imageDownloaded = new EventEmitter();

    @ViewChild('filtersWrapEl') filtersWrapEl: ElementRef;
    @ViewChild('gettyListEl') gettyListEl: ElementRef;
    @ViewChild('dateFromPicker') dateFromPicker: MatDatepicker<Date>;
    @ViewChild('dateToPicker') dateToPicker: MatDatepicker<Date>;

    @HostListener('window:resize', ['$event'])
    resize() {
        this.resizeEvent.next(true);
    }

    @HostListener('document:mousedown', ['$event'])
    @HostListener('document:keydown.escape')
    closeFilterDropdowns(e) {
        if( !e || 
            (
                (this.filtersWrapEl && !this.filtersWrapEl.nativeElement.contains(e.target)) &&
                e.target.className.indexOf('mat-calendar') === -1 &&
                e.target.className.indexOf('cdk-overlay') === -1
            )
        ) {
            const filterGroups = this.filterGroups;
            for(var i = 0; i < filterGroups.length; i++) {
                this.toggleGroupDropdown({label: null});
            }
        }
    }

    constructor(private dialog: MatDialog, public utils: Utils, public gettyService: GettyService) {    
        if( this.gettyService.searchText ) {
            this.searchField.setValue(this.gettyService.searchText);
        }     
        this.searchFieldSubscription = this.searchField.valueChanges.pipe(debounceTime(500)).subscribe(value => {
            this.gettyService.searchText = value;
            this.gettyService.search(false);
        });
        this.resizeEventSubscription = this.resizeEvent.pipe(debounceTime(250)).subscribe(() => {
            this.setMenuItemsAlignment();
        });
        this.downloadSubscription = this.gettyService.downloadComplete.subscribe(image => {
            if( this.selected && image.gettyId == this.selected.id ) {
                this.selected.downloading = false;
            }
            this.removeImage(image);
            this.deselect();
        });
        this.imagesUpdatedSubscription = this.gettyService.imagesUpdated.subscribe(() => {
            this.updateImages();
        });
    }
    ngAfterViewInit() {
        if( !this.gettyService.firstLoad ) {
            if( this.window ) {
                this.gettyService.requestFirstLoad(this.id);
            } else {
                this.gettyService.search(false);
            }
        }
        if( this.lists[0].length == 0 && this.gettyService.images.length > 0 ) {
            this.updateImages();        
        }
    }
    imageLoaded(e) {
        e.target.style.opacity = 1;
        e.target.style.transform = 'scale(1)';
    }
    staggardImageLoad(list = [], index = 0, lists, listHeights, columnWidth) {
        if( list.length == 0 || index >= list.length ) {
            return;
        }
        const image = list[index];
        const img = new Image();
        img.onload = () => {
            const newHeight = (image.height / image.width) * columnWidth;
            const shortestColumn = Math.min(...listHeights);
            const shortestIndex = listHeights.indexOf(shortestColumn);
            lists[shortestIndex].push(image);
            listHeights[shortestIndex] += newHeight;
            this.staggardImageLoad(list, index + 1, lists, listHeights, columnWidth);
        }
        img.src = image.url;
    }
    updateImagesTimeout;
    updateImages() {
        const gettyListEl = this.gettyListEl.nativeElement;
        const columnWidth = gettyListEl.offsetWidth / 3;
        if( columnWidth === 0 ) {
            this.updateImagesTimeout = setTimeout(() => {
                this.updateImages();
            }, 200);
            return;
        }
        this.updateImagesTimeout = null;
        const lists = [[], [], []];
        const listHeights = [0, 0, 0];
        this.lists = lists;
        gettyListEl.parentElement.parentElement.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        const images = this.gettyService.images;
        this.staggardImageLoad(images, 0, lists, listHeights, columnWidth);
    }
    removeImage(image) {
        const lists = this.lists;
        for(var i = 0; i < lists.length; i++) {
            const list = lists[i];
            for(var j = 0; j < list.length; j++) {
                const img = list[j];
                if( img.id == image.gettyId ) {
                    list.splice(j, 1);
                }
            }
        }
    }
    deselect() {
        this.selected = null;
    }
    select(img) {
        this.selected = img;
    }
    titleChange() {
        this.selected.title = this.cleanText(this.selected.title);
    }
    cleanText(text) {
        return text.replace(/(<([^>]+)>)/ig,'');
    }
    getCharacterCount() {
        return this.cleanText(this.selected.caption).length;
    }
    editDetails(img) {
        const dialog = this.dialog.open(EditImageDialog, {
            data: img
        });
        dialog.afterClosed().subscribe(download => {
            if( download ) {
                this.gettyService.download(img, this.id);
            }
        });
    }
    optionChanged(e, filter, index) {
        if( !this.gettyService.searchFilters[filter].multiple ) {
            const options = this.gettyService.searchFilters[filter].options;
            if( typeof this.gettyService.searchFilters[filter].search === 'string' ) {
                this.gettyService.searchFilters[filter].search = '';
                if( filter == 'date_from' ) {
                    this.resetDatePickers();
                    this.gettyService.searchFilters['date_to'].search = '';
                }
            }
            for(var i = 0; i < options.length; i++) {
                options[i].checked = false;
            }
            if( e.checked ) {
                options[index].checked = true;
            }
        }
        this.gettyService.search(false);
    }
    toggleGroupDropdown(currGroup) {
        const groupFilters = this.filterGroups;
        for(var i = 0; i < groupFilters.length; i++) {
            const group = groupFilters[i];
            if( currGroup.label == group.label ) {
                this.setMenuItemAlignment(group.label);
                group.open = !group.open;
            } else {
                group.open = false;
            }
            if( !group.open ) {
                this.toggleFilterDropdown({value: null}, group.filters);
            }
        }       
    }
    toggleFilterDropdown(filter, groupFilters) {
        for(var i = 0; i < groupFilters.length; i++) {
            const key = groupFilters[i];
            if( key == filter.value ) {
                this.gettyService.searchFilters[key].open = !this.gettyService.searchFilters[key].open;
            } else {
                this.gettyService.searchFilters[key].open = false;
            }
        }
    }
    setMenuItemAlignment(name) {
        const itemEl = document.querySelector('.filter-group-' + name + ' > ul') as HTMLElement;
        if( !itemEl ) {
            return;
        }
        const parentWidth = this.filtersWrapEl.nativeElement.offsetWidth;
        const bounds = itemEl.getBoundingClientRect();
        let marginLeft = 0;
        if( itemEl.style.marginLeft ) {
            marginLeft = parseInt(itemEl.style.marginLeft) * -1;
            marginLeft -= 10;
        }
        const itemLeft = bounds.width + bounds.left + marginLeft;
        const right = parentWidth - itemLeft;
        if( right < 0 ) {
            itemEl.style.marginLeft = Math.round(right) + 'px';
        } else {
            itemEl.style.removeProperty('margin-left');
        }
    }
    setMenuItemsAlignment() {
        const filters = this.filterGroups;
        for(var i =0; i < filters.length; i++) {
            this.setMenuItemAlignment(filters[i].label);
        }
    }
    seeAllDialog(filter) {
        const dialog = this.dialog.open(GettyFilterDialog, {
            data: {
                filter: filter,
                facet: this.gettyService.facets[filter.value]
            }
        });
    }
    resetDatePickers() {
        this.dateFromPicker.select(undefined);
        this.dateToPicker.select(undefined);
        this.minDate = undefined;
        this.fromMaxDate = new Date();
        this.toMaxDate = new Date();
    }
    removeFilter(filter) {
        filter.checked = false;
        if( filter.search ) {
            const filters = filter.search.indexOf(',') !== -1 ? filter.search.split(',') : [filter.search];
            for(var i = 0; i < filters.length; i++) {
                const key = filters[i];
                this.gettyService.searchFilters[key].search = '';
                if( key == 'date_from' || key == 'date_to' ) {
                    this.resetDatePickers();
                }
            }
        }
        this.gettyService.search(false);
    }
    firstLevel(options) {
        return options.filter(item => item.secondary === false);
    }
    goNext(prev) {
        if( prev ) {
            this.gettyService.page -= 1;
        } else {
            this.gettyService.page += 1;
        }
        this.gettyService.search(true);
    }
    dateChanged(event, filter) {
        if( !event.value ) {
            return;
        }
        if( filter === 'date_from' ) {
            this.minDate = event.value;
        }
        if( filter === 'date_to' ) {
            this.fromMaxDate = event.value;
        }
        this.gettyService.searchFilters[filter].search = this.gettyService.formatDate(event.value);
        if( this.gettyService.searchFilters.date_from.search && this.gettyService.searchFilters.date_to.search ) {
            const options = this.gettyService.searchFilters.date_from.options;
            for(var i = 0; i < options.length; i++) {
                options[i].checked = false;
            }
            this.gettyService.search(false);
        }
    }
    hideGroup(group) {
        const filters = group.filters;
        for(var i = 0; i < filters.length; i++) {
            const filter = filters[i];
            if( this.gettyService.searchFilters[filter].options.length > 0 ) {
                return false;
            }
        }
        return true;
    }
    allowLandscapeChange() {
        const image = this.selected;
        const width = 480;
        let height = 720;
        if( image.allowLandscape ) {
            height = (image.height / image.width) * width;
        }
        image.mobile = image.url + '&width=' + width + '&height=' + height;
    }
    allowPortraitChange() {
        const image = this.selected;
        const width = 800;
        let height = 533;
        if( image.allowPortrait ) {
            height = (image.height / image.width) * width;
        }
        image.desktop = image.url + '&width=' + width + '&height=' + height;
    }
    download(img, action) {
        this.gettyService.download(img, this.id, (oldImage, newImage) => this.imageDownloaded.emit({
            image: newImage,
            action: action
        }));
    }
    getDragData(img) {
        return JSON.stringify(img);
    }
    ngOnDestroy() {
        this.updateImagesTimeout = null;
        this.gettyService.resetErrors();
        if( this.searchFieldSubscription ) {
            this.searchFieldSubscription.unsubscribe();
        }
        if( this.resizeEventSubscription ) {
            this.resizeEventSubscription.unsubscribe();
        }
        if( this.imagesUpdatedSubscription ) {
            this.imagesUpdatedSubscription.unsubscribe();
        }
    }
}
@Component({
    selector: 'edit-image-dialog',
    template: `
        <h2 mat-dialog-title>Edit Image Details</h2>
        <mat-dialog-content class="getty-dialog">
            <div class="inner-wrap">
                <div class="image">
                    <img [src]="data.display_sizes[0].uri" />
                    {{data.width}}x{{data.height}}
                </div>
                <div class="input-wrap">
                    <label>Title</label>
                    <input [(ngModel)]="data.title" placeholder="Image title" name="editImageDialogTitle" autocomplete="editImageDialogTitle" id="editImageDialogTitle{{editImageDialogTitle}}">
                </div>
                <div class="input-wrap">
                    <label>Caption</label>
                    <richtext
                        class="caption"
                        [(value)]="data.caption"
                        placeholder="Caption">
                    </richtext>
                </div>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions>
            <button class="button" mat-dialog-close>Cancel</button>
            <button class="button" [mat-dialog-close]="true">Import</button>
        </mat-dialog-actions>`,
})
export class EditImageDialog {
    editImageDialogTitle = this.utils.rand();
    constructor( @Inject(MAT_DIALOG_DATA) public data: any, private utils: Utils) {
        let height = (data.height / data.width) * 1200;
        data.height = Math.floor(height);
        data.width = 1200;
    }
}
@Component({
    selector: 'getty-filter-dialog',
    template: `
        <h2 mat-dialog-title>{{data.filter.label}}</h2>
        <mat-dialog-content class="getty-filter-dialog">
            <ul class="options" *ngIf="!data.facet; else facetEl">
                <li *ngFor="let option of data.filter.options; trackBy: utils.trackByIndex">
                    <mat-checkbox [(ngModel)]="option.checked" (change)="optionChange()" [ngClass]="{'with-date': option.date}"><span class="date" *ngIf="option.date" [innerHtml]="option.date | date:'longDate'"></span><span [innerHtml]="option.label"></span></mat-checkbox>
                </li>
            </ul>
            <ng-template #facetEl>
                <ng-container *ngIf="!showFacetLetters; else facetLettersEl">
                    <ul class="options"> 
                        <li *ngFor="let option of data.facet.list; trackBy: utils.trackByIndex">
                            <mat-checkbox [checked]="option.checked" (change)="facetOptionChange($event, option)" [ngClass]="{'with-date': option.date}"><span class="date" *ngIf="option.date" [innerHtml]="option.date | date:'longDate'"></span><span [innerHtml]="option.name"></span></mat-checkbox>
                        </li>
                    </ul>
                </ng-container>
                <ng-template #facetLettersEl>
                    <ul class="letters">
                        <li *ngFor="let letter of data.facet.letters; trackBy: utils.trackByIndex" (click)="goTo(letter)">{{letter}}</li>
                    </ul>
                    <ng-container *ngFor="let letter of data.facet.letters; trackBy: utils.trackByIndex">
                        <h3 id="letter-{{letter}}">{{letter}}</h3>
                        <ul class="options"> 
                            <li *ngFor="let option of data.facet.options[letter]; trackBy: utils.trackByIndex">
                                <mat-checkbox [checked]="option.checked" (change)="facetOptionChange($event, option)" [ngClass]="{'with-date': option.date}"><span class="date" *ngIf="option.date" [innerHtml]="option.date | date:'longDate'"></span><span [innerHtml]="option.name"></span></mat-checkbox>
                            </li>
                        </ul>
                    </ng-container>
                </ng-template>
            </ng-template>
        </mat-dialog-content>
        <mat-dialog-actions>
            <button class="button" mat-dialog-close>Done</button>
        </mat-dialog-actions>`,
})
export class GettyFilterDialog {
    showFacetLetters = true;
    constructor( @Inject(MAT_DIALOG_DATA) public data: any, private gettyService: GettyService, private ref: MatDialogRef<GettyFilterDialog>, public utils: Utils) {
        this.setSelectedOptions();
    }
    setSelectedOptions() {
        if( !this.data.facet ) {
            return;
        }
        if( this.data.facet.letters.length < 2 || this.data.facet.list.length < this.data.filter.options ) {
            this.showFacetLetters = false;
        }
        const options = this.data.facet.list;
        const checkId = this.data.filter.value == 'event_ids' || this.data.filter.value == 'keyword_ids' ? true : false;
        const selected = this.data.filter.options.filter(item => item.checked).map(item => checkId ? item.value : item.value.toLowerCase());
        for(var i = 0; i < options.length; i++) {
            const option = options[i];
            const value = checkId ? option.id : option.name.toLowerCase();
            option.checked = selected.indexOf(value) === -1 ? false : true;      
        }
    }
    optionChange() {
        this.gettyService.search(false);
        this.ref.close();
    }
    facetOptionChange(e, option) {
        if( e.checked ) {
            const found = this.data.filter.options.filter(item => item.value == option.name);
            if( found.length == 0 ) {
                let selectedOption = {
                    label: option.name,
                    value: option.name,
                    secondary: false,
                    checked: true
                };
                if( this.data.filter.value == 'event_ids' ) {
                    selectedOption = Object.assign(selectedOption, {
                        value: option.id,
                        date: option.date
                    });
                }
                if( this.data.filter.value == 'keyword_ids' ) {
                    selectedOption = Object.assign(selectedOption, {
                        value: option.id
                    });
                }
                this.data.filter.options.unshift(selectedOption);
            }
        } else {
            const options = this.data.filter.options;
            let i = options.length;
            while(i--) {
                const value = options[i].value;
                const name = option.name.toLowerCase();
                if( (value + '').toLowerCase() == name || value == option.id ) {
                    options.splice(i, 1);
                }
            }
        }
        this.gettyService.search(false);
        this.ref.close();
    }
    goTo(letter) {
        const el = document.getElementById('letter-' + letter);
        if( el ) {
            el.scrollIntoView({behavior: 'smooth', block: 'start'});
        }
    }
}